import { BlogArticle } from '@models/blog';
import { Glossary } from '@models/glossary';
import { Page } from '@models/page';
import { PressRelease } from '@models/pressRelease';
import { SectionBase } from '@models/section';
import { SuccessStory } from '@models/successStory';
import { Video } from '@models/video';
import { WhitePaper } from '@models/whitePaper';

export type FeatureCardSection = SectionBase<42, FeatureCardData>;

export interface FeatureCardData {
    featureCard: FeatureCardContent;
}

export interface FeatureCardContent {
    title: string;
    cards: FeatureCard[];
}

export interface FeatureCard {
    contentType: ResourceHubContentType;
    id: number;
}

export type FeatureCardWithType =
    | (BlogArticle & { type: ResourceHubContentType.Blog })
    | (WhitePaper & { type: ResourceHubContentType.WhitePaper })
    | (SuccessStory & { type: ResourceHubContentType.SuccessStory })
    | (Glossary & { type: ResourceHubContentType.Glossary })
    | (PressRelease & { type: ResourceHubContentType.PressRelease })
    | (Video & { type: ResourceHubContentType.Video })
    | (Page & { type: ResourceHubContentType.Ebook | ResourceHubContentType.Webinar | ResourceHubContentType.Podcast | ResourceHubContentType.Guides | ResourceHubContentType.Tools });

export interface FeatureCardSelectItem {
    content: string;
    value: number;
}

export enum ResourceHubContentType {
    Blog = 'Blog',
    SuccessStory = 'Case Study',
    PressRelease = 'Press Release',
    WhitePaper = 'White Paper',
    Video = 'Video',
    Glossary = 'Glossary',
    Ebook = 'EBook',
    Webinar = 'Webinar',
    Podcast = 'Podcast',
    Guides = 'Guides',
    Tools = 'Tools'
}